import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addInfoLink: 'Add information',
    infoBoxDescription:
      'Make sure to include useful information that can help with the delivery (apartment number, name of your host, door code...).',
    infoBoxTitle: 'Help us deliver your card easily',
    next: 'Confirm my address',
    sidebarImgAlt: 'Verify your personal address',
    title: 'Verify your personal address',
  },
  fr: {
    addInfoLink: 'Ajouter des informations',
    infoBoxDescription:
      'Assurez-vous d’inclure toute information utile pour faciliter la livraison (numéro d’appartement, nom de votre hébergeur, digicode...).',
    infoBoxTitle: 'Aidez-nous à livrer votre carte facilement',
    next: 'Valider mon adresse',
    sidebarImgAlt: 'Vérifiez votre adresse personnelle',
    title: 'Vérifiez votre adresse personnelle',
  },
} as const);

export default locales;
